import { Checkbox } from 'antd';
import { getOutboundItemSku } from './outbound-import.utils';
import { OutboundModalItem } from './entry.types';

type OutboundImportModalColumnsParams = {
  existingSkuQuantities: Map<string, number>;
  isDuplicateOutboundSku: (record: OutboundModalItem) => boolean;
  onToggleItem: (key: string, selected: boolean) => void;
};

export function getOutboundImportModalColumns({
  existingSkuQuantities,
  isDuplicateOutboundSku,
  onToggleItem,
}: OutboundImportModalColumnsParams) {
  return [
    {
      title: 'Mã sản phẩm (SKU)',
      dataIndex: 'code',
      width: 140,
      render: (code: string | undefined, record: OutboundModalItem) => (
        <span className={isDuplicateOutboundSku(record) ? 'font-semibold text-amber-700' : undefined}>
          {code || '-'}
        </span>
      ),
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'name',
      ellipsis: true,
      render: (name: string | undefined) => name || '-',
    },
    {
      title: 'Số lượng',
      dataIndex: 'quantity',
      width: 120,
      align: 'right' as const,
      render: (quantity: number | undefined, record: OutboundModalItem) => {
        const sku = getOutboundItemSku(record).toLowerCase();
        const oldQuantity = existingSkuQuantities.get(sku);
        if (oldQuantity !== undefined) {
          const importingQuantity = Number(quantity || 0);
          const newQuantity = oldQuantity + importingQuantity;
          return (
            <span className="inline-flex items-center justify-end gap-2">
              <span className="line-through text-gray-400">{oldQuantity}</span>
              <span className="font-semibold text-amber-700">{newQuantity}</span>
            </span>
          );
        }
        return quantity ?? '-';
      },
    },
    {
      title: 'Import',
      width: 80,
      align: 'center' as const,
      render: (_: unknown, record: OutboundModalItem) => (
        <Checkbox checked={record.selected} onChange={e => onToggleItem(record.key, e.target.checked)} />
      ),
    },
  ];
}
